// ConvenienceTable.jsx
import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { tableColumns } from './ConvenienceData';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import { ServerPath } from '../../Constant';

const ConvenienceTable = ({ show, handleClose }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchHistoryData();
    }, [show]); // Refetch when modal is opened

    // In ConvenienceTable.jsx
    const fetchHistoryData = async () => {
        try {
            setLoading(true);
            setError(null);
            
            const response = await axios.get(`${ServerPath}/convenience-fee/history`);
            
            if (response.data.success === 1) {
                // Sort by history_id in descending order for chronological tracking
                const sortedHistory = response.data.data.sort((a, b) => b.history_id - a.history_id);
                
                const transformedData = sortedHistory.map((item, index) => {
                    // Get the new fee amount that was set at this change
                    let newFeeAmount;
                    if (index === 0) {
                        // For most recent change, use current convenience_fee_amount
                        newFeeAmount = item.convenience_fee_amount;
                    } else {
                        // For all other changes, use the previous record's previous_fee_amount
                        newFeeAmount = sortedHistory[index - 1].previous_fee_amount;
                    }
    
                    return {
                        id: item.history_id,
                        previous_fee_amount: item.previous_fee_amount,
                        convenience_fee_amount: newFeeAmount,
                        previous_min_amount: item.previous_min_amount,
                        convenience_increment: item.convenience_increment,
                        modified_by: item.changed_by,
                        modified_date: new Date(item.changed_on).toLocaleDateString('en-GB')
                    };
                });
                
                console.log('Transformed Data:', transformedData);
                setData(transformedData);
            } else {
                setError('Failed to fetch data');
            }
        } catch (error) {
            console.error('Error fetching history:', error);
            setError(error.response?.data?.message || 'Failed to fetch data');
        } finally {
            setLoading(false);
        }
    };

    const customStyles = {
        rows: {
            style: {
                minHeight: '52px',
            },
        },
        headCells: {
            style: {
                paddingLeft: '8px',
                paddingRight: '8px',
                backgroundColor: 'white',
                color: '#6B7280',
                fontSize: '0.875rem'
            },
        },
        cells: {
            style: {
                paddingLeft: '8px',
                paddingRight: '8px',
            },
        },
    };

    return (
        <Modal 
            show={show} 
            onHide={handleClose} 
            dialogClassName="modal-xl" 
            aria-labelledby="example-custom-modal-styling-title"
            style={{ minWidth: '90vw' }}
        >
            <Modal.Header closeButton>
                <Modal.Title>Convenience fee management Audit History</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && (
                    <div className="alert alert-danger" role="alert">
                        {error}
                    </div>
                )}
                <DataTable
                    columns={tableColumns}
                    data={data}
                    customStyles={customStyles}
                    pagination
                    responsive
                    highlightOnHover
                    striped
                    progressPending={loading}
                    progressComponent={
                        <div className="d-flex justify-content-center py-3">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    }
                />
            </Modal.Body>
        </Modal>
    );
};

export default ConvenienceTable;
